export default __webpack_public_path__ + "static/media/b6.251eecb6.svg";